import React, {useEffect, useState} from "react"
import {apiGet} from "../../../Api/index";
import {Div, Row} from "atomize";
import theme from "../../../Theme/Theme";
import styled from "styled-components";
import ResourceCard from "../../Molecules/ResourceCard";

const Wrapper = styled(Div)`
  margin-top: 6rem;
`;

const Heading = styled.h3`
  color: #0A1F44;	
  font-family: Inter;	
  font-size: 24px;	
  font-weight: bold;	
  line-height: 36px;
  margin-bottom: 2rem;
`;

const ResourcesWrapper = styled(Row)`
  //width: 100%;
`;

function Resources(props) {
  const [data, setData] = useState({});

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/paragraph/resources/${props.id}?include=field_resource&jsonapi_include=1`);
      setData(result.data.data);
    }

    fetchData();
  }, []);

  return (
    <Wrapper>
      <Heading>Resources</Heading>
      <ResourcesWrapper>
        {
          data.field_resource &&
          data.field_resource.map( resource => {
            return (
              <ResourceCard
                key={resource.id}
                resource={resource}
              />
            )
          })
        }
      </ResourcesWrapper>
    </Wrapper>
  )
}


export default Resources
